<template>
  <validation-provider :name="name" :rules="rules" v-slot="{ errors }">
    <div class="row">
      <input type="text" v-model="dummy_text" class="d-none" />
      <div
        :class="[
          {
            'col-lg-6': !small,
          },
          {
            'col-lg-12': small,
          },
          {
            'col-md-6': !small,
          },
          {
            'col-md-12': small,
          },
          'col-sm-12',
        ]"
      >
        <base-select
          ref="baseSelect"
          :label="label"
          :is_required="is_required"
          :options="dropdownOptions"
          field="selected"
          :value="selected"
          @change-value="setValue"
          :disabled="disabled ? true : false"
          :is_invalid="errors && errors?.length ? true : false"
          :helper_text="helper_text ? helper_text : errors && errors?.length ? errors[0] : null"
          :id="id"
          :helper_text_style="helper_text ? '' : 'color:var(--color-47);'"
          :small="small"
          :useI18n="useI18n"
          :placeholder="placeholder"
          :remoteSearch="remoteSearch"
          @search="$emit('search', $event)"
        ></base-select>
      </div>
      <div
        v-if="selectedItem"
        :class="[
          {
            'col-lg-6': !small,
          },
          {
            'col-lg-12': small,
          },
          {
            'col-md-6': !small,
          },
          {
            'col-md-12': small,
          },
          'col-sm-12',
          'multiselect-options-list',
        ]"
        :style="small ? 'margin-bottom:20px' : ''"
      >
        <div class="multiselect-option">
          <div class="cross-icon">
            <img
              src="@/assets/images/icons/cross-icon-light.svg"
              alt="cross-icon"
              @click.stop="removeItem"
              :class="{ 'pointer-events-none': disabled }"
            />
          </div>
          <div class="text">
            {{ getBoxDisplayText(selectedItem) }}
          </div>
        </div>
      </div>
    </div>
  </validation-provider>
</template>

<script>
export default {
  emits: ['change-value', 'change', 'search'],
  props: [
    'name',
    'rules',
    'label',
    'is_required',
    'options',
    'field',
    'value',
    'disabled',
    'helper_text',
    'id',
    'small',
    'useI18n',
    'placeholder',
    'dropdownTextKey',
    'boxTextKey',
    'remoteSearch',
  ],
  data() {
    return {
      selected: null,
      selectedItem: null,
      filtered_options: this.options || [],
      dummy_text: this.selectedItem?.text || null,
    }
  },
  methods: {
    setValue(val, field) {
      if (field === 'selected') {
        this.handleSelection(val)
      } else {
        this[field] = val
      }
    },
    removeItem() {
      this.handleSelection(null)
    },
    getBoxDisplayText(item) {
      if (!item) return ''

      if (this.boxTextKey && item[this.boxTextKey] !== undefined) {
        return this.useI18n ? this.$t(item[this.boxTextKey]) : item[this.boxTextKey]
      }

      // Fallback to text property
      return this.useI18n ? this.$t(item.text) : item.text
    },
    handleSelection(value) {
      if (value) {
        // Find item in filtered_options or options
        const item =
          this.filtered_options.find((each) => each.value === value) ||
          this.options?.find((each) => each.value === value)

        if (item) {
          this.selectedItem = item
          this.selected = value
          this.dummy_text = this.getBoxDisplayText(item)
        }

        this.updateFilteredOptions()
      } else {
        this.selectedItem = null
        this.selected = null
        this.dummy_text = null
        this.updateFilteredOptions()
      }

      this.$emit('change-value', value, this.field)
      this.$emit('change')
    },
    updateFilteredOptions() {
      // Keep all options including selected one for base-select to display properly
      this.filtered_options = this.options || []
    },
  },
  computed: {
    dropdownOptions() {
      // Transform options to show dropdownTextKey in dropdown, but keep all data
      return this.filtered_options.map((option) => {
        if (this.dropdownTextKey && option[this.dropdownTextKey] !== undefined) {
          return {
            ...option,
            text: option[this.dropdownTextKey],
          }
        }
        return option
      })
    },
  },
  watch: {
    options() {
      this.updateFilteredOptions()
      if (this.value && this.value !== this.selected) {
        this.handleSelection(this.value)
      }
    },
    value(val) {
      if (val !== this.selected) {
        this.handleSelection(val)
      }
    },
  },
  mounted() {
    if (this.value) {
      this.handleSelection(this.value)
    } else {
      this.updateFilteredOptions()
    }
  },
}
</script>

<style lang="scss" scoped>
.multiselect-options-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .multiselect-option {
    display: flex;
    align-items: center;
    margin: 5px 10px 0px 0px;
    background: var(--color-23);
    border-radius: 6px;
    padding: 0.4rem;
    .cross-icon {
      margin-inline-end: 0.5rem;
      cursor: pointer;
    }
    .text {
      font-weight: 600;
      font-size: 14px;
      color: var(--color-01);
    }
  }
  .pointer-events-none {
    pointer-events: none;
  }
}
</style>
